import { styles } from './template.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { InputWidthValues } from '../../../../ui/gzInput/index';
import { FontSizes } from '../../../../types/common/types';
export const templateGCPSensor = document.createElement('template');

templateGCPSensor.innerHTML = `
  <style>${styles}</style>
  <style>${styleHelpersStyles}</style>
  <div class="form-wrapper" id="integration-types" class="sensor-wrapper">
    <gz-form-field  class="sensor-select-wrapper">
       <gz-checkbox gz-form-input class="sensor-select" style="display: none" checked></gz-checkbox>
    </gz-form-field>
    <div class="sensor-data">
      <div class="sensor-data-list">
        <gz-form-field label="" id="subscription_id" required stacked class="mb-3">
          <gz-input gz-form-input="" type="text" inputWidth='${InputWidthValues.XLARGE}'></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>

      <div class="sensor-data-list">
        <gz-form-field label="" id="gcp_import_file_wrapper" stacked>
          <gz-text id="label_for_gcp_file_above" fontSize="${FontSizes.PARAGRAPH_12}" class="mb-2"></gz-text>
          <div  class="mb-2">
            <label id="label_for_gcp_file" for="gcp_import_file"></label>
          </div>
          <gz-file-input gz-form-input id="gcp_import_file" accept=".json" class="mb-1"  showFileNames="true">
            <gz-button
                  id='gcp_btn_import_file'
                  browse-button
                  type='full'
                  color= 'primary'
                  buttonHeight='medium'
                  buttonFontSize='medium'
                  lowercase='true'
                >
              </gz-button>
           </gz-file-input>
        </gz-form-field>
      </div>
    </div>
  </div>
`;
